import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WarningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"warning"}/>
}
